module.exports = __webpack_public_path__ + "static/media/5.7a59a578.svg";